import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import {
  CreatePaymentRequestFormData,
  CreatePaymentRequestResponse,
} from './types';

export default (makeCall: MakeCall) => (
  data: CreatePaymentRequestFormData,
): Promise<{ data: CreatePaymentRequestResponse }> =>
  makeCall<CreatePaymentRequestResponse>('POST', '/api/payments/requests/v3', {
    data,
  });
